const BALANCES_TITLE = 'NAVIGATION.BALANCES.LABEL';
const REPORTINGS_TITLE = 'NAVIGATION.REPORTINGS.LABEL';
const ACCOUNT_GROUPS_TITLE = 'NAVIGATION.MASTER_DATA_MENU.ACCOUNT_GROUPS_STATEMENTS';
const ACCOUNT_TITLE = 'NAVIGATION.MASTER_DATA_MENU.ACCOUNT_STATEMENTS';
const EMPTY_TITLE = '';

const noBreadcrumbNoDetailStateNameToPageTitleMap = new Map([
  // DashBoardController
  ['app.dashboard', EMPTY_TITLE],
  // arsAccountsController
  ['app.accounts', BALANCES_TITLE],
  ['app.accountsByCurrency', BALANCES_TITLE],
  ['app.accountsByCountry', BALANCES_TITLE],
  ['app.accountsByBank', BALANCES_TITLE],
  ['app.accountsByGroup', BALANCES_TITLE],
  // ValueSeriesController
  ['app.valueseries', BALANCES_TITLE],
  // CommonViewController
  ['app.statements', REPORTINGS_TITLE],
  ['app.intradays', REPORTINGS_TITLE],
  ['app.erroneousstatements', REPORTINGS_TITLE],
  ['app.settings', 'USER_MENU.USERPROFILE_SETTINGS'],
  ['app.password', 'USER_MENU.CHANGE_PASSWORD'],
  ['app.exportDownloadSettings', 'USER_MENU.EXPORT_DOWNLOAD_SETTINGS'],
  ['app.downloadSettings', 'USER_MENU.EXPORT_DOWNLOAD_SETTINGS'],
  ['app.administrationAccounts', ACCOUNT_TITLE],
  ['app.noReportingAccounts', ACCOUNT_TITLE],
  ['app.noMovementAccounts', ACCOUNT_TITLE],
  ['app.accountGroups', ACCOUNT_GROUPS_TITLE],
  ['app.userReports', 'NAVIGATION.MASTER_DATA_MENU.USER_DEFINED_REPORTS'],
  ['app.transactions', 'NAVIGATION.TRANSACTIONS.LABEL'],
  ['app.downloadsarchive', 'PAGE_TITLE.DOWNLOADS_ARCHIVE'],
  // AddController
  ['app.widgets', EMPTY_TITLE],
  // fsLoginController
  ['public.login', EMPTY_TITLE],
  // undefined
  ['public.logout', EMPTY_TITLE],
  ['app.about', 'PAGE_TITLE.ABOUT'],
  ['otherwise', EMPTY_TITLE],
  // ExportModalController
  ['app.export', EMPTY_TITLE],
  // FsGotoController
  ['app.goto', EMPTY_TITLE],
  // AddGroupController
  ['app.addGroup', ACCOUNT_GROUPS_TITLE],
  // 'GroupDetailController'
  ['app.viewGroup', ACCOUNT_GROUPS_TITLE],
  ['app.editGroup', ACCOUNT_GROUPS_TITLE],
  // AddUserReportController
  ['app.accountsUserReport', EMPTY_TITLE],
  ['administration.addUserReport', EMPTY_TITLE],
  // AdministrationAccountsTableController
  ['administration.deleteAccount', EMPTY_TITLE],
  // SendReportingDeleteConfirmationController
  ['app.noReportingAccountsDelete', EMPTY_TITLE],
  ['app.noMovementAccountsDelete', EMPTY_TITLE],
  ['administration.deleteAccountConfirmation', EMPTY_TITLE],
  // DeleteConfirmationController
  ['administration.deleteGroup', ACCOUNT_GROUPS_TITLE],
  ['administration.deleteUserReport', EMPTY_TITLE],
  // EditAccountController
  ['administration.editAccount', ACCOUNT_TITLE],
  // EditUserReportController
  ['administration.editUserReport', EMPTY_TITLE],
  // AddAccountController
  ['administration.addAccount', ACCOUNT_TITLE],
]);

export const getTitleFromStateName = (stateName: string): string | null => {
  if (!noBreadcrumbNoDetailStateNameToPageTitleMap.has(stateName)) {
    return null;
  }

  return noBreadcrumbNoDetailStateNameToPageTitleMap.get(stateName) as string;
};
